<template>
  <div style="height: 100%; background: #F2F2F6">
         <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>系统设置</el-breadcrumb-item>
          <el-breadcrumb-item>职员管理</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ name: 'Account' }">职员列表</el-breadcrumb-item>
          <el-breadcrumb-item>修改职员</el-breadcrumb-item>
        </el-breadcrumb>
      
    <el-row style="padding: 30px">
      <el-col :span="12">
        <el-form
        size="mini"
          :model="customer"
          :rules="rules"
          ref="customerForm"
          label-width="150px"
          label-position="right"
        >
          <el-form-item label="用户名" prop="username">
            <el-input v-model="customer.username" disabled maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="name">
            <el-input v-model="customer.name" maxlength="20"></el-input>
          </el-form-item>
            <el-form-item label="手机号" prop="mobile">
            <el-input v-model="customer.mobile" :disabled="customer.mobilevalid==1" maxlength="11"></el-input>
            <el-button v-if="customer.mobilevalid" @click="customer.mobilevalid=0" type="text">手机号已验证，点击修改</el-button>
          </el-form-item>
          <el-form-item label="电子邮箱" prop="email">
            <el-input v-model="customer.email" :disabled="customer.emailvalid==1" maxlength="30"></el-input>
             <el-button v-if="customer.emailvalid" @click="customer.emailvalid=0" type="text">邮箱已验证，点击修改</el-button>
          </el-form-item>
          <el-form-item label="权限组" prop="roleid">
          <el-select v-model="customer.roleid" clearable placeholder="请选择">
    <el-option
      v-for="item in roles"
      :key="item.innerid"
      :label="item.name"
      :value="item.innerid">
    </el-option>
  </el-select>
          </el-form-item>
          <el-divider></el-divider>
          <el-form-item>
            <el-button type="primary" @click="saveUser()">保存</el-button>
            <el-button @click="back()">取消</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'CreateUser',
  data () {
    return {
      customer: {
      },
       roles:[],
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ]
      }
    }
  },
  mounted: function () {
    let customer = window.localStorage.getItem('customer')
    let self=this;
    if (customer) {
        Vue.axios
          .post('/factory/role/all', {})
          .then((res) => {
            if (res.data.errcode == 0) {
              self.roles = res.data.msgbody
            }
          })

       Vue.axios
          .post('/factory/user/query', {
            innerid: this.$route.params.innerid
          })
          .then((res) => {
            if (res.data.errcode == 0) {
              self.customer = res.data.msgbody
            } else {
              this.$message({
                showClose: true,
                message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
                type: 'error'
              })
            }
          })
       
    } else {
      this.$message({
        message: '无登录信息，请重新登录',
        type: 'warning'
      })
      this.$router.push({ name: 'Login' })
    }
  },
  methods: {
    saveUser () {
      this.$refs.customerForm.validate((valid) => {
        if (valid) {
          var self = this
          Vue.axios
            .post('/factory/user/update',
              self.customer
            )
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  message: '帐号更新成功',
                  type: 'success'
                })
                this.$router.back()
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
                  type: 'error'
                })
              }
            })
        } else {
          return false
        }
      })
    },
    back () {
      this.$router.back()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/User/Edit.vue